import React, { Component } from 'react';
import axios from 'axios';
import '../css/header.css';
import { Container } from 'react-bootstrap';

let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/post_data_client_genesys_web';
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';

class EncabezadoCliente extends Component {
  constructor() {
      super();
      this.state = {
          obserbaciones_contacto: []
      };
  }
  async componentDidMount() {
      
      //console.log('llamo servicio mostrar obserbacion')
      //console.log('valido dato:  ' +this.props.data)
      const body = {
          id_contacto: this.props.data
      }
      //console.log(body)
      await axios.post(baseUrl,body)
          .then(response => {
              //console.log('exito get_evaluadores: ' + JSON.stringify(response.data));
              this.setState({obserbaciones_contacto:response.data});
              //console.log(response)
          })
          .catch(response => {
              console.log(response + ' error get_evaluadores')
          }
      )
      
  }
  render() {
    const { obserbaciones_contacto } = this.state;
    //console.log('length evaluadores: '+evaluadores.length)
    let contactoList = obserbaciones_contacto.length > 0
        && obserbaciones_contacto.map((item, i) => {
            return (
              <Container key={i++}>
                <br/>
                <div className="about">
                  <hr/>
                  <section id="about" className="about">
                    <div className="container" data-aos="fade-up">
                      <div className="row">
                        <div className="col-lg-12 pt-4 pt-lg-0 content">
                          <h3>Datos Cliente.</h3>
                          <div className="row">
                            <div className="col">
                              <ul>
                                <li><i className="bi bi-chevron-right"></i> <strong>Nombre Completo:</strong> <span>{item.con_metadata.nombre+' '+item.con_metadata.ap_paterno+' '+item.con_metadata.ap_materno}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Rut:</strong> <span>{item.con_metadata.rut+item.con_metadata.dv}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Genero:</strong> <span>{item.con_metadata.sexo}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Mail:</strong> <span>{item.con_metadata.mail}</span></li>
                              </ul>
                            </div>
                            <div className="col">
                              <ul>
                                <li><i className="bi bi-chevron-right"></i> <strong>Fecha de nacimiento:</strong> <span>{item.con_metadata.fecha_nacimiento}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Edad:</strong> <span>{item.con_metadata.edad}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Direcccion:</strong> <span>{item.con_metadata.direccion}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Comuna:</strong> <span>{item.con_metadata.comuna}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Fecha de contratacion:</strong> <span>{item.con_metadata.opcional21}</span></li>
                              </ul>
                            </div>
                            <div className="col">
                              <ul>
                                <li><i className="bi bi-chevron-right"></i> <strong>Campaña:</strong> <span>{item.con_metadata.opcional1}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>SGE1:</strong> <span>{item.con_metadata.opcional4}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>seguro contratado:</strong> <span>{item.con_metadata.opcional20}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Producto:</strong> <span>{item.con_metadata.opcional2}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Nro Tarjeta cv:</strong> <span>{item.con_metadata.opcional11}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>Nro Tarjeta tc:</strong> <span>{item.con_metadata.opcional12}</span></li>
                              </ul>
                            </div>
                            <div className="col">
                              <ul>
                                <li><i className="bi bi-chevron-right"></i> <strong>Marca visita:</strong> <span>{item.con_metadata.opcional16}</span></li>
                                <li><i className="bi bi-chevron-right"></i> <strong>WSP:</strong> <span>{item.con_metadata.opcional6}</span></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>         
              </Container>         
            )
        }, this);
      return (
          <>
              {contactoList}  
          </>
      );
  }

}

export default EncabezadoCliente;